/**
 * Which SFX to play after a successful daily claim (day 7 ladder = milestone sting).
 */

import { SOUND_IDS } from '../../shared/constants/sounds.constants';
import type { SoundId } from '../../shared/constants/sounds.constants';
import { getRealActiveStreak } from './dailyClaimStreakDisplay.helper';

export const getDailyClaimSuccessSoundId = (
  dailyClaimStreak: number,
  lastDailyClaimAt: string | null
): SoundId => {
  const active = getRealActiveStreak(dailyClaimStreak, lastDailyClaimAt);
  const ladderDay = active > 0 ? ((active - 1) % 7) + 1 : 1;
  return ladderDay === 7 ? SOUND_IDS.STREAK_MILESTONE : SOUND_IDS.DAILY_CLAIM;
};
